import styled from 'styled-components'

export const Previews = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
`

export const Preview = styled.div`
  position: relative;
  min-width: 0;
  border: 0.0625rem solid var(--border);
  border-radius: 0.375rem;
  overflow: hidden;
`

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 6rem;
  object-fit: contain;
  background: var(--muted);
`

export const Caption = styled.div`
  padding: 0.375rem;
`

export const Remove = styled.div`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
`
